import { render } from "./prechatConfiguration.vue?vue&type=template&id=137094ef&lang=pug"
import script from "./prechatConfiguration.vue?vue&type=script&lang=js"
export * from "./prechatConfiguration.vue?vue&type=script&lang=js"

import "./prechatConfiguration.vue?vue&type=style&index=0&id=137094ef&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__